import FlavorDecompositionSubTable from './FlavorDecompositionSubTable';
export default FlavorDecompositionSubTable;